export const convertPastDaysToDate = (lastPurchaseDay: number) => {
    const today = new Date()

    const todayDate = new Date(today)
    todayDate.setDate(today.getDate() - lastPurchaseDay)
    const lastPurchaseDate = todayDate.toISOString().split('T')[0]

    return lastPurchaseDate
}
